import React from 'react'
import './skills.css'
import Stars from '../components/Stars';

function skills() {

  return (
    <>
    <Stars/>
    <div className='container'>
      <h1 className='title'>SKILLS</h1>
      <div className='section'>
        <h2 className='head'>LANGUAGES</h2>
        <div className='flexy'>
          <div className='stack'>
            <img src='https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/1200px-Python-logo-notext.svg.png'></img>
            <p>Python</p>
          </div>
          <div className='stack'>
            <img src='https://static-00.iconduck.com/assets.00/java-icon-1511x2048-6ikx8301.png'></img>
            <p>Java</p>
          </div>
          <div className='stack'>
            <img src='https://cdn.worldvectorlogo.com/logos/logo-javascript.svg'></img>
            <p>JavaScript</p>
          </div>
          <div className='stack'>
            <img src='https://cdn.iconscout.com/icon/free/png-256/free-html-logo-icon-download-in-svg-png-gif-file-formats--technology-social-media-vol-3-pack-logos-icons-3030115.png?f=webp&w=256'></img>
            <p>HTML</p>
          </div>
          <div className='stack'>
            <img src='https://cdn-icons-png.flaticon.com/512/732/732190.png'></img>
            <p>CSS</p>
          </div>
        </div>
        <div className='flexy'>
        <div className='stack'>
            <img src='https://symbols.getvecta.com/stencil_27/79_sql-database-generic.494ff6320e.png'></img>
            <p>SQL</p>
          </div>
          <div className='stack'>
            <img src='https://cdn-icons-png.flaticon.com/512/6132/6132222.png'></img>
            <p>C++</p>
          </div>
          <div className='stack'>
            <img src='https://static-00.iconduck.com/assets.00/typescript-icon-icon-1024x1024-vh3pfez8.png'></img>
            <p>TypeScript</p>
          </div>
          <div className='stack'>
            <img src='https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/C_Programming_Language.svg/926px-C_Programming_Language.svg.png'></img>
            <p>C</p>
          </div>
          <div className='stack'>
            <img src='https://static-00.iconduck.com/assets.00/dart-icon-2042x2048-775u9j9x.png'></img>
            <p>Dart</p>
          </div>
        </div>
      </div>
      
      <div className='section'>
        <h2 className='head'>FRAMEWORKS / LIBRARIES</h2>
        <div className='flexy'>
          <div className='stack'>
            <img src='https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1150px-React-icon.svg.png'></img>
            <p>React</p>
          </div>
          <div className='stack'>
            <img src='https://cdn.iconscout.com/icon/free/png-256/free-flutter-logo-icon-download-in-svg-png-gif-file-formats--programming-language-coding-development-logos-icons-1720090.png?f=webp'></img>
            <p>Flutter</p>
          </div>
          <div className='stack'>
            <img src='https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Spring_Boot.svg/512px-Spring_Boot.svg.png'></img>
            <p>Spring Boot</p>
          </div>
          <div className='stack'>
            <img src='https://www.manektech.com/storage/developer/1646733543.webp'></img>
            <p>Express</p>
          </div>
        </div>
        <div className='flexy'>
          <div className='stack'>
            <img src='https://wallpapers.com/images/hd/stylized-wave-graphic-sqx8hfk01muragyg.jpg'></img>
            <p>Flask</p>
          </div>
          <div className='stack'>
            <img src='https://www.svgrepo.com/show/374118/tailwind.svg'></img>
            <p>Tailwind CSS</p>
          </div>
          <div className='stack'>
            <img src='https://static-00.iconduck.com/assets.00/socket-io-icon-512x511-xjp7kzx6.png'></img>
            <p>SocketIO</p>
          </div>
          <div className='stack'>
            <img src='https://img.icons8.com/color/512/pandas.png'></img>
            <p>pandas</p>
          </div>
        </div>
      </div>
      
      <div className='section'>
        <h2 className='head'>DATABASES</h2>
        <div className='flexy'>
          <div className='stack'>
            <img src='https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg'></img>
            <p>mongoDB</p>
          </div>
          <div className='stack'>
            <img src='https://cdn4.iconfinder.com/data/icons/google-i-o-2016/512/google_firebase-2-512.png'></img>
            <p>Firebase</p>
          </div>
          <div className='stack'>
            <img src='https://cdn-icons-png.flaticon.com/512/528/528260.png'></img>
            <p>MySQL</p>
          </div>
        </div>
      </div>
      
      <div className='section'>
        <h2 className='head'>CLOUD</h2>
        <div className='flexy'>
          <div className='stack'>
            <img src='https://cdn.icon-icons.com/icons2/2407/PNG/512/aws_icon_146074.png'></img>
            <p>Amazon AWS</p>
          </div>
          <div className='stack'>
            <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHT9Ar8biWe6fPFefEXy5v0tgr2DcBaEl4W-O_Gq2iT17NLnu1i5E8kWgPKhVWo3CrpoY&usqp=CAU'></img>
            <p>Oracle OCI</p>
          </div>
        </div>
      </div>
    </div>
    
    </>
  )
}

export default skills